import { ResultSheetModelType } from '@models/ResultSheet';
import { apolloClient } from '@lib/apollo';
import {
  UPSERT_RESULT_SHEET,
  upsertResultSheetMutation,
  upsertResultSheetMutationVariables,
} from '@app-types/graphql-types';
import { AddToast } from 'react-toast-notifications';
import { logError } from '@lib/logger';

interface SubmitResultSheetArgs {
  resultSheet: ResultSheetModelType;
  batchClassId: string;
  batchSubjectConfigurationId: string;
  addToast: AddToast;
  submit?: boolean;
}

export const submitResultSheet = async ({
  resultSheet,
  batchClassId,
  batchSubjectConfigurationId,
  addToast,
  submit,
}: SubmitResultSheetArgs): Promise<void> => {
  try {
    await apolloClient.mutate<upsertResultSheetMutation, upsertResultSheetMutationVariables>({
      mutation: UPSERT_RESULT_SHEET,
      variables: {
        data: {
          batchClassId,
          batchSubjectConfigurationId,
          submit,
          studentResultSheets: resultSheet.studentResultSheets.map((studentResultSheet) => ({
            customMarks: studentResultSheet.customMarks,
            remark: studentResultSheet.remarks,
            studentId: studentResultSheet.id,
            studentResults: studentResultSheet.studentResults.map((studentResult) => ({
              batchSubjectExtraSlotId: studentResult.batchSubjectExtraSlotId,
              assessmentId: studentResult.assessmentId,
              firstAttemptMarks: studentResult.firstAttemptMarks,
              isFirstAttemptNYC: studentResult.isFirstAttemptNYC || false,
              secondAttemptMarks: studentResult.secondAttemptMarks,
              isSecondAttemptNYC: studentResult.isSecondAttemptNYC || false,
              thirdAttemptMarks: studentResult.thirdAttemptMarks,
              isThirdAttemptNYC: studentResult.isThirdAttemptNYC || false,
            })),
          })),
        },
      },
    });

    addToast('Result sheet successfully saved.', {
      appearance: 'success',
      autoDismiss: true,
    });
  } catch (error) {
    addToast('Error. Something went wrong. Please try again.', {
      appearance: 'error',
      autoDismiss: true,
    });

    logError(error);
  }
};
